export const GET_POLICY_ENDPOINT = (entity, ext) => `/s3/post-policy/${entity}/${ext}`
